/**
 * Lookbook mosaic grid — "available only" toggle.
 *
 * The mosaic layout (tall-left / two-stacked-centre / tall-right, repeating
 * every 4 tiles) is driven purely by :nth-child position in fdl-landing.css.
 * To keep that pattern correct when filtering, sold-out tiles are removed
 * from the DOM (not just hidden with CSS) so the remaining tiles regain
 * clean 1..N positions, then re-inserted in original order when the toggle
 * is switched off.
 */
(function () {
  function initToggle(toggle) {
    var wrap = toggle.closest('.fdl-v2-wrap');
    if (!wrap) return;

    var grid = wrap.querySelector('[data-fdl-lb-grid]');
    if (!grid) return;

    var emptyMessage = wrap.querySelector('[data-fdl-lb-filtered-empty]');

    // Snapshot every tile once, in its original document order.
    var allTiles = Array.prototype.slice.call(
      grid.querySelectorAll('.fdl-v2-lb-tile')
    );
    if (!allTiles.length) return;

    function apply() {
      var availableOnly = toggle.checked;
      var visible = availableOnly
        ? allTiles.filter(function (tile) {
            return tile.getAttribute('data-available') !== 'false';
          })
        : allTiles;

      // replaceChildren both detaches the filtered-out tiles and re-inserts
      // the visible ones in order — appendChild alone would only move the
      // visible tiles, leaving the filtered-out ones behind in the grid.
      grid.replaceChildren.apply(grid, visible);

      if (emptyMessage) {
        emptyMessage.hidden = visible.length !== 0;
      }
    }

    toggle.addEventListener('change', apply);

    // Re-sync in case the browser restores a checked state from bfcache
    // (back/forward navigation) without re-running this script fresh.
    apply();
  }

  document
    .querySelectorAll('[data-fdl-lb-availability-toggle]')
    .forEach(initToggle);
})();
